import { addDays } from 'date-fns';
import { getUTCMidDay } from 'utils/date';

/** Evaluations can be scheduled up to this date in the future */
export const MAX_DAYS_FOR_FIRST_EVALUATION = 21;

/** How many days from today to wait before first day that can be picked for evaluation */
export const EVALUATION_CALENDAR_DATE_QUERY_OFFSETS = {
  INSURANCE: 7,
  PRIVATE_PAY: 3,
};

export const getEvaluationCalendarQueryOffsetNumber = (isPrivatePay: boolean): number => {
  return isPrivatePay
    ? EVALUATION_CALENDAR_DATE_QUERY_OFFSETS.PRIVATE_PAY
    : EVALUATION_CALENDAR_DATE_QUERY_OFFSETS.INSURANCE;
};

/** From current date */
export const getEvaluationCalendarQueryOffset = (isPrivatePay: boolean): Date => {
  const from = getUTCMidDay();
  return addDays(from, getEvaluationCalendarQueryOffsetNumber(isPrivatePay));
};
